import React, {useMemo} from 'react';
import MarkdownIt from 'markdown-it';
import clsx from 'clsx';

import {withStyles} from 'common/util/react';

import {MarkdownProps} from './types';
import styles from './index.module.styl';
import css from './index.module.styl?inline';

// adds blank targets to all links
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const linkOpenRule = (tokens: any[], idx: number, options: any, _env: any, self: any): string => {
  if (tokens[idx].tag === `a`) {
    tokens[idx].attrPush([`target`, `_blank`]);
    tokens[idx].attrPush([`rel`, `noreferrer noopener`]);
  }
  return self.renderToken(tokens, idx, options) as string;
};

function Markdown({text, allowBreaks, linkify, multiLine, truncate, className, style}: MarkdownProps) {
  const markup = useMemo(() => {
    const converter = new MarkdownIt();
    converter.renderer.rules.link_open = linkOpenRule;

    if (allowBreaks || linkify) {
      converter.set({breaks: allowBreaks, linkify});
    }

    if (multiLine) {
      return converter.render(text).trim();
    }

    return converter.renderInline(text).trim();
  }, [text, allowBreaks, linkify, multiLine]);

  return (
    <div
      className={clsx(styles.container, {[styles.truncate]: truncate}, className)}
      style={style}
      // The markdown library handles sanitization for us.
      // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{__html: markup}}
    />
  );
}

export const MarkdownReact = withStyles(Markdown, css);
